export enum CategoryType {
  COMPRENDRE = "COMPRENDRE",
  PRATIQUER = "PRATIQUER",
  EXPLORER = "EXPLORER",
}

export enum ExerciseType {
  MICRO_COURS = "MICRO_COURS",
  QUIZ = "QUIZ",
  ANALYSE_RAPIDE = "ANALYSE_RAPIDE",
  COGNITIF = "COGNITIF",
  DEFIS_REELS = "DEFIS_REELS",
  SIMULATION = "SIMULATION",
  ILLUSION = "ILLUSION",
  HISTOIRE = "HISTOIRE",
  CREATIVITE = "CREATIVITE",
}

export interface ExerciseBase {
  id: string;
  title: string;
  description: string;
  category: CategoryType;
  type: ExerciseType;
  estimatedDuration?: number;
  level?: "débutant" | "intermédiaire" | "avancé";
}
